import React from "react";
import { useSelector } from "react-redux";
import { Stack, Tab, Tabs } from "@mui/material";
import { useTheme } from "@mui/styles";
import Summary from "./Summary";
import InsuranceCard from "../Components/InsuranceCard";
import ConfirmAccountDetails from "../Components/ConfirmAccountDetails";
import SidePanelDrawer from "components/ClientDetails/Widgets/SidePanelDrawer";

import { IntakeProvider } from "../IntakeProvider";
import { STAGES } from "../utils";
import * as selectors from "selectors";
import DiagnosisReport from "../Components/DiagnosisReport";
import { useParams } from "react-router-dom";

export default function IntakeSpecialistExperience({ open, onClose }) {
  const theme = useTheme();
  const { id } = useParams();
  const clientId = useSelector(selectors.getCustomerClientId) || id;
  const customerDetails = useSelector(selectors.getCustomerDetails);
  const workflowStatus = useSelector(selectors.getCustomerWorkflowStatus);
  const isActive = customerDetails?.details?.is_active;
  const hasStartedIntake = isActive && workflowStatus === "SELF_SERVICE_INTAKE";

  const stagesOrder = [
    STAGES.summary.name,
    STAGES.confirmAccountDetails.name,
    STAGES.insuranceCard.name,
    STAGES.diagnosisReport.name,
  ];

  return (
    <IntakeProvider
      initialValues={{
        currentStage: STAGES.summary.name,
        stagesOrder,
        clientId,
        isSpecialist: true,
      }}
    >
      {({ currentStage, setCurrentStage, setCurrentSubStage, history }) => {
        return (
          <SidePanelDrawer
            open={open}
            onClose={onClose}
            title="Client Intake"
            width={760}
            bodyPadding={0}
          >
            <Stack gap={theme.spacing(5)} padding={theme.spacing(7)} direction="row">
              {hasStartedIntake && (
                <Stack sx={{ flexShrink: 0 }}>
                  <Tabs
                    orientation="vertical"
                    sx={{
                      "& .MuiTab-root": {
                        alignItems: "flex-start",
                        maxWidth: "none",
                        minWidth: 220,
                        whiteSpace: "nowrap",
                      },
                    }}
                    value={currentStage}
                    onChange={(_, newValue) => {
                      setCurrentStage(newValue);
                      // Reset the subStage when changing the stage
                      setCurrentSubStage(history[newValue]?.at(-1), false);
                    }}
                  >
                    <Tab label="Summary" value={STAGES.summary.name} />
                    <Tab
                      label="Confirm account details"
                      value={STAGES.confirmAccountDetails.name}
                    />
                    <Tab label="Insurance card" value={STAGES.insuranceCard.name} />
                    <Tab label="Diagnosis report" value={STAGES.diagnosisReport.name} />
                  </Tabs>
                </Stack>
              )}
              <Stack width="512px" height="calc(100vh - 111px)" overflow="auto">
                {currentStage === STAGES.summary.name && (
                  <Summary onClose={onClose} hasStartedIntake={hasStartedIntake} />
                )}
                {currentStage === STAGES.confirmAccountDetails.name && (
                  <ConfirmAccountDetails padding={theme.spacing(0, 7, 7)} />
                )}
                {currentStage === STAGES.insuranceCard.name && (
                  <InsuranceCard padding={theme.spacing(0, 7, 7)} />
                )}
                {currentStage === STAGES.diagnosisReport.name && (
                  <DiagnosisReport padding={theme.spacing(0, 7, 7)} />
                )}
              </Stack>
            </Stack>
          </SidePanelDrawer>
        );
      }}
    </IntakeProvider>
  );
}
